import apiClient from "../Config/Index";

class GalleryApi {
  async getGallery(params = {}) {
    try {
      const response = await apiClient.get("/gallery", { params });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      return { status: false, response: error?.response?.data || error };
    }
  }

  async getGalleryById(id) {
    try {
      const response = await apiClient.get(`/gallery/${id}`);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      return { status: false, response: error?.response?.data || error };
    }
  }

  async createGallery(data) {
    try {
      const response = await apiClient.post("/gallery", data);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      return { status: false, response: error?.response?.data || error };
    }
  }

  async updateGallery(id, data) {
    try {
      const response = await apiClient.put(`/gallery/${id}`, data);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      return { status: false, response: error?.response?.data || error };
    }
  }

  async deleteGallery(id) {
    try {
      const response = await apiClient.delete(`/gallery/${id}`);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      return { status: false, response: error?.response?.data || error };
    }
  }
}

export default new GalleryApi();
